import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Comprehensive PostHog/third-party error suppression
const suppressThirdPartyErrors = (event) => {
  const message = event.message || event.reason?.toString() || '';
  const source = event.filename || '';
  
  // Suppress PostHog-related errors
  const suppressPatterns = [
    'postMessage',
    'PerformanceServerTiming',
    'posthog',
    'ph_',
    'array.js',
    'ResizeObserver loop',
    'Non-Error promise rejection'
  ];
  
  if (suppressPatterns.some(pattern => 
    message.includes(pattern) || source.includes(pattern)
  )) {
    event.preventDefault?.();
    event.stopPropagation?.();
    return true;
  }
  return false;
};

// Suppress error events
window.addEventListener('error', suppressThirdPartyErrors, true);
window.addEventListener('unhandledrejection', suppressThirdPartyErrors, true);

const rootElement = document.getElementById("root");

// Support for react-snap prerendering - use hydrate for pre-rendered HTML
if (rootElement.hasChildNodes()) {
  // Page was pre-rendered, hydrate it
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // No pre-rendered content, render normally
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}
